import TelemetryButton from "@/design-system/telemetry-button";
import type { ITelemetryButtonProps } from "@/design-system/telemetry-button";
import type { PropsWithStyleX } from "@/styles/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

export type IButtonsBarV2 = PropsWithStyleX & {
    cancelButton: ITelemetryButtonProps;
    cancelButtonText?: string;
    nextButton: ITelemetryButtonProps;
    nextButtonText?: string;
};

const ButtonsBarV2: React.FC<IButtonsBarV2> = (props) => {
    const cancelBtn: ITelemetryButtonProps = {
        ...props.cancelButton,
    };

    const nextBtn: ITelemetryButtonProps = {
        ...props.nextButton,
    };

    return (
        <div {...stylex.props(styles.contentWrapper, props.styleX)}>
            {props.cancelButton && <TelemetryButton {...cancelBtn}>{props.cancelButtonText}</TelemetryButton>}

            <TelemetryButton {...nextBtn}>{props.nextButtonText}</TelemetryButton>
        </div>
    );
};
const styles = stylex.create({
    contentWrapper: {
        display: "flex",
        textAlign: "center",
    },
});

export default ButtonsBarV2;
